import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Globe } from "lucide-react";
import { useCredits } from "../context/CreditsContext";
import { api } from "../lib/api";

const day = (iso) => new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short" });

export const DomainRenewalBar = ({ className = "" }) => {
  const { credits } = useCredits();
  const [r, setR] = useState(null);
  useEffect(() => { if (credits) api.domainRenewal().then(setR).catch(() => {}); }, [credits]);
  if (!r || (!r.paused.length && !r.warn)) return null;
  const paused = r.paused.length > 0;
  return (
    <div role="status" data-testid="domain-renewal-bar"
      className={`relative z-10 flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 px-4 py-2 text-sm border-b ${paused ? "bg-rose-50 border-rose-200 text-rose-900" : "bg-amber-50 border-amber-200 text-amber-900"} ${className}`}>
      <Globe size={14} className="shrink-0" />
      <span data-testid="domain-renewal-message">
        {paused
          ? <><b>{r.paused.map((p) => p.domain).join(", ")}</b> {r.paused.length > 1 ? "are" : "is"} paused — this month's domain fee couldn't be taken. Top up and it comes back online automatically.</>
          : <>Your custom domain{r.live_count > 1 ? "s renew" : " renews"} on <b>{day(r.renews_on)}</b> for <b>{r.due} credits</b> — you have {r.balance}. Top up to keep {r.live_count > 1 ? "them" : "it"} online.</>}
      </span>
      <Link to="/billing" data-testid="domain-renewal-topup" className="h-7 px-3 rounded-full bg-slate-900 text-white text-xs font-semibold flex items-center hover:bg-slate-700 transition-colors">Top up credits</Link>
    </div>
  );
};

export default DomainRenewalBar;
